import AccountingPage from "@/pages/accounting/AccountingPage";
import AppLayout from '@/components/layouts/AppLayout'
import BookingsPage from "@/pages/bookings/BookingsPage";
import DashboardPage from '@/pages/dashboard/DashboardPage'
import ForgotPasswordPage from "@/pages/auth/forgot-password/ForgotPasswordPage";
import ConfirmEmailPage from "@/pages/auth/confirm-email/ConfirmEmailPage";
import InfoPage from "@/pages/info/InfoPage";
import InfoPageEdit from "@/pages/info/InfoPageEdit";
import LoginPage from "@/pages/auth/login/LoginPage";
import ResetPasswordPage from "@/pages/public/ResetPasswordPage";
import Router from "vue-router";
import SeatsPage from '@/pages/seats/SeatsPage'
import SettingsPage from "@/pages/settings/SettingsPage";
import SignupPage from "@/pages/auth/signup/SignupPage";
import UserDetailPage from "@/pages/superadmin/users/UserDetailPage";
import VerifyEmailPage from "@/pages/public/VerifyEmailPage";
import Vue from "vue";
import WelcomePage from "@/pages/welcome/WelcomePage";
import superadminRoutes from "./modules/superadmin";

Vue.use(Router);

export const router = new Router({
  mode: "history",
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      name: "AppLayout",
      component: AppLayout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "/dashboard",
          name: "DashboardPage",
          component: DashboardPage,
          meta: {
            title: "Urbnx | Web Dashboard - Dashboard"
          }
        },
        {
          path: "/welcome",
          name: "WelcomePage",
          component: WelcomePage,
          meta: {
            title: "Urbnx | Web Dashboard - Welcome"
          }
        },
        {
          path: '/seats',
          name: 'SeatsPage',
          component: SeatsPage,
          meta: {
            title: 'Urbnx | Web Dashboard - Seats'
          }
        },
        {
          path: '/space/:id?/edit',
          name: 'InfoPageEdit',
          component: InfoPageEdit,
          meta: {
            title: "Urbnx | Web Dashboard - Info"
          }
        },
        {
          path: '/space/:id',
          name: 'InfoPage',
          component: InfoPage,
          meta: {
            title: "Urbnx | Web Dashboard - Info"
          }
        },
        {
          path: "/settings",
          name: "SettingsPage",
          component: SettingsPage,
          meta: {
            title: "Urbnx | Web Dashboard - Settings"
          }
        },
        {
          path: "/accounting",
          name: "AccountingPage",
          component: AccountingPage,
          meta: {
            title: "Urbnx | Web Dashboard - Accounting"
          }
        },
        {
          path: "/bookings",
          name: "BookingsPage",
          component: BookingsPage,
          meta: {
            title: "Urbnx | Web Dashboard - Bookings"
          }
        },
        {
          path: "/users/:id",
          name: "UserDetailPage",
          component: UserDetailPage,
          meta: {
            title: "Urbnx | Web Dashboard - User"
          }
        },
        ...superadminRoutes
      ]
    },
    {
      path: "/login",
      name: "LoginPage",
      component: LoginPage,
      meta: {
        title: "Urbnx | Web Dashboard - Login"
      }
    },
    {
      path: "/forgot-password",
      name: "ForgotPasswordPage",
      component: ForgotPasswordPage,
      meta: {
        title: "Urbnx | Web Dashboard - Forgot Password"
      }
    },
    {
      path: "/confirm-email",
      name: "ConfirmEmailPage",
      component: ConfirmEmailPage,
      meta: {
        title: "Urbnx | Web Dashboard - Verify Email"
      }
    },
    {
      path: "/sign-up",
      name: "SignupPage",
      component: SignupPage,
      meta: {
        title: "Urbnx | Web Dashboard - Signup"
      }
    },

    /** Deep Links */
    {
      path: "/verifyEmail",
      name: "VerifyEmailPage",
      component: VerifyEmailPage,
      meta: {
        title: "Urbnx | Web Dashboard - Verify Email"
      }
    },
    {
      path: "/resetPassword",
      name: "ResetPasswordPage",
      component: ResetPasswordPage,
      meta: {
        title: "Urbnx | Web Dashboard - Reset Password"
      }
    },

    /** Redirect to Home */
    {
      path: "*",
      redirect: "/"
    }
  ]
});

router.beforeEach((to, from, next) => {
  // Meta and Page Title
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  // Requires Login
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem("token")) {
      location.href = "/login";
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js